<template>
  <div class="textarea" :class="{ 'disabled': disabled }" >
    <textarea :placeholder="placeholder" :name="name" :id="id" :rows="rows" :cols="cols" :type="type" :value="value" v-model="input" :autofocus="autofocus"/>
  </div>
</template>

<script>

export default {
  name: 'TextArea',
  props: {
    name: String,
    id: String,
    placeholder: String,
    type: String,
    value: String,
    maxlength: Number,
    disabled: {
      type: Boolean,
      default: false
    },
    rows: Number,
    cols: Number,
    autofocus: {
      type: Boolean,
      deafult: false
    }
  },
  watch: {
    input(value) {
      this.$emit('update', value);
    },
    value(newVal) {
      // Keep internal v-model in sync when parent updates the value
      this.input = newVal;
    }
  },
  data() {
    return {
      input: this.value
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .textarea {
    width: 100%;
    height: auto;
    position: relative;
    font-size: 12px;
    text-align: left;
    cursor: pointer;

    &.disabled {
      opacity: .5;
      pointer-events: none;
    }

    textarea {
      width: 100%;
      max-width: 100%;
      min-width: 100%;
      height: auto;
      padding: 10px;
      color: $general-black-light;
      -webkit-appearance: none;
      border: solid 1px hsl(255, 0%, 85%);
      border-radius: 3px;
      resize: vertical;

      &:focus { 
        outline: none !important;
        border-color: $brand-primary;
      }
    }

  }
</style>
